export type RowActions = {
  primary: Array<string>;
  secondary: Array<string>;
  rowClick: string | null;
};

export type RowData = {
  id: string;
  rowNumber: string;
  [p: string]: unknown;
  actions: RowActions;
};
